// extracted by mini-css-extract-plugin
module.exports = {"root":"ContactFooter_root__3rT2T","section":"ContactFooter_section__fKzIC","contentWrapper":"ContactFooter_contentWrapper__iYfHU"};